import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '@core/service/base.service';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StockTableDtService extends BaseService{

  private url = "api/stock_table_dt";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

  getByMatId(id:number):Observable<any> {
    const url = `${this.getUrl()}/existBy/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }

}
